import { getIntl } from '@/locales/intl';
import { shellMessageId, translateShellText } from '@/locales/shellText';
import { useLocaleStore } from '@/stores/localeStore';

export function useShellText() {
  const locale = useLocaleStore((state) => state.locale);
  return (zh: string, en: string, params?: Record<string, string | number>) => {
    const id = shellMessageId(zh);
    const intl = getIntl();
    if (id in intl.messages) {
      return intl.formatMessage({ id }, params);
    }

    return translateShellText(locale, zh, en, params);
  };
}
